<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <h3>{{$route.meta.title}}</h3>

      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :show-header="false"
                  class="table-panel">
      <el-button type="primary"
                 size="mini"
                 @click="$router.push({name: '新增任务包'})">新增任务包
      </el-button>

      <el-button type="primary"
                 size="mini"
                 @click="$router.push({name: '任务包预览'})">预览
      </el-button>
    </layout-panel>

    <layout-panel :show-header="false">
      <el-table ref="multipleTable"
                :data="table"
                stripe
                highlight-current-row>
        <el-table-column prop="id"
                         label="ID"></el-table-column>
        <el-table-column prop="customername"
                         label="客户"></el-table-column>
        <el-table-column prop="name"
                         label="任务名称"></el-table-column>

        <el-table-column prop="batchids"
                         label="批次编号">
          <template slot-scope="scope">
            {{scope.row.batchids ? scope.row.batchids.join(',') : ''}}
          </template>
        </el-table-column>

        <el-table-column prop="starttime"
                         label="上线时间">
          <template slot-scope="scope">
            <span>{{scope.row.starttime === '0000-00-00 00:00:00' ? '-' : scope.row.starttime}}</span>
          </template>
        </el-table-column>

        <el-table-column prop="endtime"
                         label="下线时间">
          <template slot-scope="scope">
            <span>{{scope.row.endtime === '0000-00-00 00:00:00' ? '-' : scope.row.endtime}}</span>
          </template>
        </el-table-column>

        <el-table-column prop="endtime"
                         label="状态">
          <template slot-scope="scope">
            <span>{{ scope.row.starttime|getPackageStatus(scope.row.endtime) }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="memo"
                         label="备注">
        </el-table-column>

        <el-table-column prop="priority"
                         label="优先级"></el-table-column>

        <el-table-column fixed="right"
                         label="操作"
                         width="150">
          <template slot-scope="scope">
            <el-button plain
                       type="primary"
                       size="mini"
                       @click="$router.push({name: '修改任务包', params: {packageId: scope.row.id}})">修改
            </el-button>

            <el-button plain
                       type="danger"
                       size="mini"
                       @click="onDelete(scope.row.id)">删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
  </div>
</template>


<script>
import table from '@core/mixins/table'


export default {
  mixins: [table],



  data () {
    return {}
  },



  created () {
  },



  methods: {
    getTableData (params) {
      return request.page('getHomeTaskPackageTable', params)
    },


    onDelete (id) {
      this.$confirm('确认删除此任务包?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        request.common('deleteHomeTaskPackage', id).then((res) => {
          this.$message({
            showClose: true,
            message: '删除成功',
            type: 'success',
          })
          this.onSearch()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
        })
      })
    },
  },
  filters: {
    getPackageStatus (starttime, endtime) {
      return moment().isBetween(starttime, endtime) ? '上线' : '下线'
    },
  },
}
</script>


<style lang="scss"
       scoped
       src="../../platform-user/style/PlatformUser.scss"></style>



// WEBPACK FOOTER //
// src/views/task-package-home/pages/TaskPackageHomeTable.vue